module.exports = __webpack_public_path__ + "img/icon-a-2.9b5e2d0e.svg";